/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Domain_Exceeds_Free_TInputs */

const en_premium_domain_exceeds_free_t = /** @type {(inputs: Premium_Domain_Exceeds_Free_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium Domain (Exceeds free tier)`)
};

const es_premium_domain_exceeds_free_t = /** @type {(inputs: Premium_Domain_Exceeds_Free_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio Premium (Excede el nivel gratuito)`)
};

const fr_premium_domain_exceeds_free_t = /** @type {(inputs: Premium_Domain_Exceeds_Free_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domaine Premium (Dépasse le forfait gratuit)`)
};

const de_premium_domain_exceeds_free_t = /** @type {(inputs: Premium_Domain_Exceeds_Free_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Premium-Domain (Überschreitet die kostenlose Stufe)`)
};

const ja_premium_domain_exceeds_free_t = /** @type {(inputs: Premium_Domain_Exceeds_Free_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プレミアムドメイン (無料枠を超過)`)
};

const zh_premium_domain_exceeds_free_t = /** @type {(inputs: Premium_Domain_Exceeds_Free_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`高级域名 (超出免费套餐范围)`)
};

const ar_premium_domain_exceeds_free_t = /** @type {(inputs: Premium_Domain_Exceeds_Free_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نطاق مميز (يتجاوز الباقة المجانية)`)
};

const id_premium_domain_exceeds_free_t = /** @type {(inputs: Premium_Domain_Exceeds_Free_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain Premium (Melebihi paket gratis)`)
};

const it_premium_domain_exceeds_free_t = /** @type {(inputs: Premium_Domain_Exceeds_Free_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominio Premium (Supera il piano gratuito)`)
};

const ru_premium_domain_exceeds_free_t = /** @type {(inputs: Premium_Domain_Exceeds_Free_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Премиум-домен (Превышает бесплатный тариф)`)
};

const pt_premium_domain_exceeds_free_t = /** @type {(inputs: Premium_Domain_Exceeds_Free_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domínio Premium (Excede o plano gratuito)`)
};

const ko_premium_domain_exceeds_free_t = /** @type {(inputs: Premium_Domain_Exceeds_Free_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`프리미엄 도메인 (무료 한도 초과)`)
};

/**
* | output |
* | --- |
* | "Premium Domain (Exceeds free tier)" |
*
* @param {Premium_Domain_Exceeds_Free_TInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const premium_domain_exceeds_free_t = /** @type {((inputs?: Premium_Domain_Exceeds_Free_TInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Domain_Exceeds_Free_TInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_premium_domain_exceeds_free_t(inputs)
	if (locale === "es") return es_premium_domain_exceeds_free_t(inputs)
	if (locale === "fr") return fr_premium_domain_exceeds_free_t(inputs)
	if (locale === "de") return de_premium_domain_exceeds_free_t(inputs)
	if (locale === "ja") return ja_premium_domain_exceeds_free_t(inputs)
	if (locale === "zh") return zh_premium_domain_exceeds_free_t(inputs)
	if (locale === "ar") return ar_premium_domain_exceeds_free_t(inputs)
	if (locale === "id") return id_premium_domain_exceeds_free_t(inputs)
	if (locale === "it") return it_premium_domain_exceeds_free_t(inputs)
	if (locale === "ru") return ru_premium_domain_exceeds_free_t(inputs)
	if (locale === "pt") return pt_premium_domain_exceeds_free_t(inputs)
	return ko_premium_domain_exceeds_free_t(inputs)
});